import { put, getContext } from "redux-saga/effects";
import importer from "common/importer";
const { getCountries } = importer("GraphQL/Queries");
const PublicContentActions = importer("Stores/PublicContent/Actions");
export default function* main() {
  try {
    yield put(PublicContentActions.getCountriesLoading());
    const apolloClient = yield getContext("client");
    const query = getCountries;
    const { data, error } = yield apolloClient.query({ query });
    if (error) {
      throw error;
    }
    const countries = data.pdt_country.map((c) => ({
      description: c.description,
      code: c.code,
      isd: c.isd,
      display_order: c.display_order,
    }));
    yield put(PublicContentActions.getCountriesSuccess(countries));
  } catch (error) {
    yield put(PublicContentActions.getCountriesFailure(error));
  }
}
